import * as React from "react";
import {ReactNode} from "react";
import SelectCheckBoxesComponent from "../common/SelectCheckBoxesComponent";
import {IPlanInfo} from "../../model/ClientsAndPlans.model";
import {REQUEST_STATES, RequestState, getSuccessData} from "../common/commonStates";
import {useDispatch, useSelector} from "react-redux";
import getRelatedPlansActions from "../client/Client.actions";
import {LoadingSpinner} from "../icons/LoadingSpinner.component";
import {relatedPlans} from "../../../mainReducerMapSelectors";
import {AnyThunkDispatch} from "../../../commonTypes";

export interface IPlanSelectPropsFromParent {
    onSelectElementsCallBack: (arg: number[]) => void;
    selectedElements: number[];
    currentPlan: IPlanInfo;
    children?: ReactNode;
}

export type IPlanSelectProps = IPlanSelectPropsFromParent;

export const PlanSelect: React.FunctionComponent<IPlanSelectProps> = (props: IPlanSelectProps) => {
    const relatedPlansFromStore: RequestState<IPlanInfo[]> = useSelector(relatedPlans);
    const dispatch: AnyThunkDispatch = useDispatch();

    if (relatedPlansFromStore.kind === REQUEST_STATES.NOT_REQUESTED) {
        dispatch(getRelatedPlansActions.getRelatedPlans(props.currentPlan.id));
    }

    if (relatedPlansFromStore.kind === REQUEST_STATES.REQUESTED) {
        return <LoadingSpinner/>;
    }

    const plansToDisplay = getSuccessData(relatedPlansFromStore)!;

    if (!plansToDisplay || plansToDisplay.length <= 1) {
        return null;
    }

    return <div data-testid="plan-select">
        {props.children}
        <SelectCheckBoxesComponent
            elements={plansToDisplay}
            onSelectElementsChange={props.onSelectElementsCallBack}
            selectedElements={props.selectedElements}
            noElementsSelectedMsg={"Please select at least one plan."}
            maxOneColumn={5}
        />
    </div>;
};
